import { usePlayer } from '../../hooks/PlayerProvider';
import { useCurrentAsset } from '../../hooks/CurrentAssetProvider';
import { usePlayerState } from '../../hooks/usePlayerState';
import { usePaywallState } from '../../hooks/usePaywallState';
import { useProvider } from '../../hooks/useProvider';
import { useIcons } from '../../hooks/useIcons';
import { getAssetAccess } from '../../../../utils/player/asset';
import { getNativeAudioLink } from '../../utils/nativeAudioLink';
import { AudioNativePlayButton } from '../../components/AudioNativePlayButton/AudioNativePlayButton';
import { PaywallButtons } from '../../components/PaywallButtons/PaywallButtons';
import { Typography } from '../../components/Typography/Typography';
import { AudioPlayer } from '../AudioPlayer/AudioPlayer';
import { usePlayerError } from '../../hooks/PlayerErrorProvider';

export const PodcastPlayerOnlyLayout = () => {
  const state = usePlayerState();
  const player = usePlayer();
  const { asset } = useCurrentAsset();
  const { configProvider } = useProvider();
  const { Play } = useIcons();

  const durationInMinutes =
    asset?.duration && asset.duration > 0
      ? Math.ceil(asset.duration / 1000 / 60)
      : null;
  const accessLevel = getAssetAccess(asset);
  const { hasAccess } = usePaywallState(accessLevel);
  const nativeAudioLink = hasAccess
    ? getNativeAudioLink(asset, configProvider)
    : undefined;
  const { errorDetails } = usePlayerError();

  const isPlaying = state !== 'idle' && hasAccess;

  if (isPlaying || errorDetails) {
    return <AudioPlayer />;
  }

  if (!hasAccess && asset) {
    return (
      <PaywallButtons
        color="primary"
        size="standard"
        asset={asset}
        accessLevel={accessLevel}
        variant="podcast"
      />
    );
  }

  return (
    <div className="vgp-podcast-player-only-idle">
      <AudioNativePlayButton
        href={nativeAudioLink}
        onClick={() => {
          player.setMute(false);
          player.play();
        }}
        size="medium"
        className="vgp-podcast-layout-play-button"
      >
        <Play />
      </AudioNativePlayButton>
      {durationInMinutes !== null && (
        <Typography variant="label" size="medium" color="primary">
          {durationInMinutes} min
        </Typography>
      )}
    </div>
  );
};
